var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _g11, _path5, _path6, _g12, _g13, _g14, _g15, _g16, _g17, _rect5, _rect6, _rect7, _g18, _g19, _g20, _g21, _g22, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1673(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 810.5,
    height: 728.683,
    viewBox: "0 0 810.5 728.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1673",
    "data-name": "Group 1673",
    transform: "translate(-295.596 -120.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1549",
    "data-name": "Group 1549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1548",
    "data-name": "Group 1548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M799.453,159.984l35.052,11.693c-8.129,11.888-8.364,26.454-7.545,39.8-12.571-1.66-26.129,1.342-37.8-3.743C785.607,191.925,791.623,174.038,799.453,159.984Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M798.494,155.621l35.053,11.695c-8.129,11.886-8.365,26.452-7.546,39.8-12.571-1.661-26.129,1.341-37.8-3.743C784.65,187.563,790.664,169.676,798.494,155.621Z",
    fill: "#fde427"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M822.478,176.37a81.048,81.048,0,0,0-20.618-6.334.692.692,0,0,1,.226-1.364,82.585,82.585,0,0,1,20.973,6.443.692.692,0,0,1-.581,1.255Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M819.961,181.417c-8.153-3.831-16.851-6.193-25.433-8.839-.848-.262-.259-1.513.58-1.255,8.583,2.646,17.28,5.008,25.433,8.839a.692.692,0,0,1-.58,1.255Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M820.485,186.992c-8.129-1.853-15.325-6.27-23.021-9.3-.829-.327-.247-1.581.58-1.255,7.574,2.986,14.668,7.372,22.667,9.2.865.2.643,1.562-.226,1.364Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M815.948,190.418c-8.089-3.506-16.217-6.922-24.344-10.339-.822-.346-.241-1.6.581-1.255,8.126,3.417,16.255,6.833,24.343,10.339.817.354.238,1.61-.58,1.255Z",
    fill: "#92a32b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1553",
    "data-name": "Group 1553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1552",
    "data-name": "Group 1552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M433.282,232.712l-38.654,6.15c6.435,13.829,4.158,29.091.991,42.894,13.424.443,27.072,5.928,40.146,2.635C442.217,268.489,439.03,248.756,433.282,232.712Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M435.039,228.32l-38.654,6.149c6.435,13.829,4.158,29.091.991,42.894,13.424.443,27.073,5.928,40.146,2.635C443.974,264.1,440.787,244.364,435.039,228.32Z",
    fill: "#bee41b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M406.381,245.848a85.881,85.881,0,0,1,22.644-3.048.732.732,0,0,0,0-1.464,87.375,87.375,0,0,0-23.032,3.1.732.732,0,0,0,.388,1.411Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M408.138,251.557c9.184-2.59,18.682-3.552,28.109-4.83.932-.127.533-1.537-.39-1.412-9.426,1.278-18.924,2.24-28.108,4.831a.732.732,0,0,0,.389,1.411Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M406.626,257.293c8.815-.529,17.1-3.9,25.668-5.736.923-.2.531-1.609-.389-1.411-8.432,1.808-16.605,5.163-25.279,5.683-.938.057-.943,1.521,0,1.464Z",
    fill: "#92a32b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M410.774,261.659c9.06-2.263,18.145-4.425,27.229-6.588.919-.219.529-1.63-.389-1.412-9.084,2.163-18.17,4.325-27.23,6.588a.733.733,0,0,0,.39,1.412Z",
    fill: "#92a32b"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1557",
    "data-name": "Group 1557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1556",
    "data-name": "Group 1556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M945.12,297.186l-33.383,1.758c4.39,14.035-1.1,30.371,4.546,44.67,9.254-1.126,21.461-.413,30.462-3.534C947.432,327.141,949.329,309.178,945.12,297.186Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M947.757,293.672l-33.384,1.758c4.39,14.035-1.1,30.371,4.546,44.671,9.254-1.127,21.461-.414,30.461-3.535C950.068,323.627,951.965,305.664,947.757,293.672Z",
    fill: "#fde427"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M921.175,309.358c1.948.829,4.741-.03,6.71-.394,3.005-.555,5.993-1.342,9.031-1.7.925-.11.937-1.575,0-1.464-2.685.318-5.329.95-7.977,1.476-1.368.272-2.739.527-4.119.725a6.4,6.4,0,0,1-2.906.1c-.858-.365-1.6.9-.739,1.264Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M919.348,314.728c8.274-.948,16.343-3.074,24.351-5.3a.733.733,0,0,0-.39-1.412c-7.876,2.185-15.822,4.311-23.961,5.244-.926.106-.937,1.572,0,1.464Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M921.984,318.681c4.538-.609,8.914-2.093,13.37-3.1.921-.208.53-1.619-.389-1.411-4.322.977-8.581,2.457-12.981,3.048-.922.124-.934,1.589,0,1.464Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M923.108,320.953c.573.915,1.929.8,2.856.739a37.766,37.766,0,0,0,5.732-1c4.044-.921,8.066-2.051,12-3.357.891-.3.509-1.709-.39-1.411-3.308,1.1-6.674,2.038-10.053,2.888-1.917.482-3.848.921-5.8,1.234-.441.071-2.874.5-3.083.167-.5-.8-1.766-.064-1.264.738Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M924.426,322.411c-.451.707-.886.779-.978,1.687a.733.733,0,0,0,.732.732,39.7,39.7,0,0,0,14.248-2.662c.869-.339.492-1.756-.389-1.411a38.591,38.591,0,0,1-13.859,2.609c.244.244.487.488.732.732.02-.2.653-.752.778-.948.509-.8-.758-1.533-1.264-.739Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M929.08,326.486c2.433,1.627,5.964,1,8.715.979a.732.732,0,0,0,0-1.464c-2.459.017-5.813.667-7.976-.779-.787-.526-1.519.743-.739,1.264Z",
    fill: "#d3b81a"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1559",
    "data-name": "Group 1559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558",
    "data-name": "Group 1558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M595.871,315.18l-33.383,1.757c4.389,14.035-1.1,30.372,4.545,44.671,9.254-1.126,21.461-.414,30.462-3.534C598.182,345.135,600.079,327.172,595.871,315.18Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M598.507,311.666l-33.384,1.757c4.39,14.035-1.1,30.372,4.546,44.671,9.254-1.127,21.461-.414,30.462-3.534C600.818,341.621,602.715,323.658,598.507,311.666Z",
    fill: "#fde427"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M571.925,327.352c1.948.829,4.742-.031,6.71-.394,3.005-.556,5.993-1.343,9.031-1.7.926-.11.937-1.575,0-1.464-2.684.318-5.329.95-7.977,1.476-1.368.271-2.739.527-4.118.725a6.4,6.4,0,0,1-2.907.094c-.858-.365-1.6.9-.739,1.265Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M570.1,332.722c8.274-.949,16.342-3.075,24.35-5.3a.733.733,0,0,0-.389-1.412c-7.876,2.185-15.823,4.311-23.961,5.244-.927.106-.937,1.571,0,1.464Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M572.734,336.675c4.538-.61,8.914-2.094,13.37-3.1.921-.208.53-1.619-.389-1.411-4.321.976-8.58,2.457-12.981,3.048-.922.123-.934,1.589,0,1.464Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M573.858,338.947c.573.915,1.929.8,2.856.738a37.662,37.662,0,0,0,5.732-1c4.044-.921,8.065-2.052,12-3.357.891-.3.509-1.71-.389-1.412-3.309,1.1-6.675,2.039-10.054,2.889-1.917.482-3.848.921-5.8,1.234-.441.071-2.874.5-3.082.166-.5-.8-1.767-.063-1.265.739Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M575.176,340.4c-.451.708-.886.78-.978,1.687a.732.732,0,0,0,.732.732,39.722,39.722,0,0,0,14.248-2.661c.869-.34.492-1.756-.389-1.412a38.549,38.549,0,0,1-13.859,2.609c.243.244.488.488.732.732.02-.2.653-.751.778-.948.509-.8-.759-1.533-1.264-.739Z",
    fill: "#d3b81a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M579.831,344.48c2.432,1.626,5.963,1,8.714.978a.732.732,0,0,0,0-1.463c-2.459.016-5.813.667-7.975-.779-.788-.526-1.52.742-.739,1.264Z",
    fill: "#d3b81a"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1565",
    "data-name": "Group 1565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1564",
    "data-name": "Group 1564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M484.619,191.454a327.3,327.3,0,0,1-1.561-39.072c-9.468,7.14-36.082,1.449-36.082,1.449,2.414,13.919,3.629,31.3.113,44.651C459.381,197.476,472.533,194.649,484.619,191.454Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M486.376,187.939a327.271,327.271,0,0,1-1.561-39.071c-9.469,7.139-36.082,1.449-36.082,1.449,2.414,13.919,3.63,31.3.113,44.65C461.137,193.961,474.29,191.135,486.376,187.939Z",
    fill: "#ff5593"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M459.938,162.931c2.365,1.651,5.736,1.324,8.432.978a61.223,61.223,0,0,0,9.7-2.222.733.733,0,0,0-.389-1.412,70.312,70.312,0,0,1-8.326,2.019c-2.652.452-6.315,1.022-8.678-.627-.776-.542-1.506.728-.739,1.264Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M460.5,169.153c3.421-.53,6.915-.391,10.346-.852.922-.124.934-1.589,0-1.464-3.562.479-7.182.354-10.735.9-.931.144-.534,1.555.389,1.411Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M459.5,170.836c3.248,2.5,8.064,1.4,11.789.979.927-.106.937-1.571,0-1.464-3.446.392-8.051,1.53-11.05-.778-.748-.576-1.476.7-.739,1.263Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M456.111,177.5c6.511-1.805,13.346-1.745,20.007-2.609.923-.12.935-1.585,0-1.464-6.789.881-13.759.822-20.4,2.661a.733.733,0,0,0,.39,1.412Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M458.99,182.355c4.328-.479,8.655-.946,12.931-1.782.927-.182.533-1.593-.389-1.412-4.148.812-8.344,1.266-12.542,1.73-.927.1-.938,1.568,0,1.464Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M459.79,185.215c1.243.971,3.5.326,4.9.094a67.292,67.292,0,0,0,7.231-1.662.733.733,0,0,0-.389-1.412c-1.919.543-3.863,1-5.818,1.4-1.037.21-2.081.392-3.133.506-.362.039-1.53.216-1.756.04-.734-.574-1.778.454-1.035,1.035Z",
    fill: "#aa3c6e"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1567",
    "data-name": "Group 1567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1566",
    "data-name": "Group 1566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M867.219,265.292a327.5,327.5,0,0,1,8.151-38.244c-10.94,4.577-35.319-7.52-35.319-7.52-1.1,14.084-4.225,31.225-10.935,43.291C841.275,264.885,854.718,265.4,867.219,265.292Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M869.791,262.322a327.237,327.237,0,0,1,8.15-38.244c-14.431-3.389-35.319-7.52-35.319-7.52-1.1,14.084-4.225,31.225-10.934,43.291C843.847,261.914,857.289,262.429,869.791,262.322Z",
    fill: "#46f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M850.36,231.551c1.883,2.185,5.23,2.7,7.928,3.034a61.2,61.2,0,0,0,9.948.246.733.733,0,0,0-.028-1.464,70.575,70.575,0,0,1-8.567-.1c-2.681-.218-6.371-.571-8.253-2.754-.618-.717-1.64.333-1.028,1.042Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M849.367,237.72c3.446.332,6.8,1.331,10.236,1.733.923.108,1.3-1.309.362-1.418-3.57-.418-7.047-1.434-10.626-1.779-.937-.09-.9,1.375.028,1.464Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M847.979,239.1c2.528,3.225,7.466,3.353,11.18,3.863.924.127,1.3-1.29.362-1.418-3.435-.473-8.178-.509-10.514-3.488-.582-.742-1.6.311-1.028,1.043Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M843.048,244.719c6.755-.138,13.363,1.61,20.032,2.421.923.112,1.3-1.3.362-1.419-6.8-.826-13.536-2.607-20.422-2.466a.733.733,0,0,0,.028,1.464Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M844.636,250.137c4.312.607,8.62,1.225,12.971,1.472.942.053.91-1.411-.028-1.464-4.22-.24-8.4-.838-12.581-1.426-.923-.13-1.3,1.287-.362,1.418Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M844.705,253.107c.964,1.248,3.314,1.182,4.724,1.3a67.245,67.245,0,0,0,7.417.178.733.733,0,0,0-.027-1.464c-1.995.051-3.992.017-5.983-.083-1.057-.053-2.114-.136-3.162-.285-.36-.052-1.536-.169-1.711-.4-.569-.738-1.836,0-1.258.747Z",
    fill: "#16b1b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1574",
    "data-name": "Group 1574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1569",
    "data-name": "Group 1569",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1568",
    "data-name": "Group 1568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M580.3,278.3c.005-.026.009-.053.014-.08-.024.005-.048.008-.072.012Q579.782,278.71,580.3,278.3Z",
    fill: "#16b1b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M677.634,200c1.77-21.759,2.014-43.619,2.681-65.367-3.813-.506-7.683-.836-11.578-1.05a3.733,3.733,0,0,0-.386-.052,3.821,3.821,0,0,0-.556,0c-9.774-.49-19.69-.253-29.258-.1-11.476.187-23.846-.376-35.337.666l-14.854-.309a3.705,3.705,0,0,0-1.784-.037l-11.038-.23c7.418,20.789,6.628,50.229,7.759,72.245,1.215,23.615,1.314,49.045-2.973,72.449,13.931-2.643,31.281,4.612,46.087,4.13,13.714-.447,28.658-2.9,41.474-5.328.394-11.247,4.672-22.588,6.238-33.81C676.093,228.98,676.468,214.327,677.634,200Z",
    fill: "#16b1b5"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1573",
    "data-name": "Group 1573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1572",
    "data-name": "Group 1572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1570",
    "data-name": "Group 1570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M591.326,271.529l.008-.081c-.023.006-.047.011-.07.018Q590.849,271.979,591.326,271.529Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M681.98,185.581c0-21.832-1.537-43.639-2.638-65.369-13.786-.7-28.109.863-41.738,2.2-11.422,1.119-23.8,1.564-35.167,3.535l-27.63,1.675c9.082,20.117,10.687,49.524,13.6,71.376,3.128,23.438,5.294,48.776,2.923,72.451,13.67-3.767,31.553,2.054,46.27.371,13.633-1.559,28.328-5.218,40.9-8.68-.521-11.242,2.821-22.893,3.469-34.205C682.8,214.588,681.983,199.953,681.98,185.581Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1571",
    "data-name": "Group 1571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M605.573,158.842c3.782,1.065,8.02-.224,11.629-1.372,4.745-1.509,9.28-3.493,14.059-4.928,11.639-3.5,23.614-6.021,35.827-5.467,1.35.062,1.344-2.032,0-2.093-11.607-.527-23.005,1.7-34.118,4.877-4.781,1.366-9.336,3.084-13.992,4.791-3.812,1.4-8.76,3.325-12.848,2.174a1.047,1.047,0,0,0-.557,2.018Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M605.721,169.8c18.741-10.814,40.562-17.4,62.026-19.777,1.326-.147,1.34-2.241,0-2.093-21.845,2.422-44,9.052-63.082,20.062a1.047,1.047,0,0,0,1.056,1.808Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M600.454,175.705c17.827-8.022,37.845-8.26,56.377-13.912,1.287-.393.738-2.413-.557-2.018-18.727,5.711-38.855,6.014-56.876,14.122-1.23.553-.165,2.356,1.056,1.808Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M609.422,178.023c16.5-2.218,32.995-4.451,49.384-7.377,1.328-.237.763-2.254-.557-2.019-16.388,2.926-32.887,5.16-49.383,7.378-1.333.179-.763,2.2.556,2.018Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M608.207,188.351c2.674.691,5.545.258,8.222-.188a107.972,107.972,0,0,0,12.433-3.078c8.184-2.388,16.287-5.455,24.677-7.062,1.324-.253.762-2.271-.557-2.018-7.836,1.5-15.43,4.3-23.058,6.583-4.046,1.212-8.118,2.365-12.256,3.219-2.808.58-6.061,1.26-8.9.526a1.047,1.047,0,0,0-.557,2.018Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M612.436,196.5c10.9.778,22.175-2.125,32.543-5.2a1.048,1.048,0,0,0-.557-2.019c-10.209,3.03-21.251,5.892-31.986,5.127-1.347-.1-1.338,2,0,2.093Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M618.281,204.313c3.648,3.793,11.271,1.637,15.6.551a87.57,87.57,0,0,0,17.277-6.289c1.211-.6.15-2.4-1.056-1.808a88.987,88.987,0,0,1-15.314,5.69,45.213,45.213,0,0,1-9,1.708c-1.951.136-4.557.194-6.025-1.332-.937-.974-2.416.508-1.48,1.48Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M629.936,215.648c5.146,1.552,10.65.92,15.88.192,6.2-.864,12.357-2.314,18.638-2.368a1.047,1.047,0,0,0,0-2.093c-5.578.048-11.095,1.172-16.584,2.048-5.641.9-11.791,1.887-17.377.2a1.047,1.047,0,0,0-.557,2.018Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M607.447,230.4c18.231-5.386,37.887-2.744,55.969-8.853,1.271-.43.725-2.452-.557-2.018-18.076,6.107-37.735,3.466-55.969,8.853a1.047,1.047,0,0,0,.557,2.018Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M615.729,243.72c14.535-1.046,27.534-9.425,42.141-10.328,1.341-.083,1.349-2.177,0-2.094-7.252.449-14.238,2.647-21.1,4.88-6.831,2.221-13.813,4.929-21.037,5.449-1.339.1-1.348,2.19,0,2.093Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M621.573,245.622c-.884.741-1.859.734-2.245,1.937a1.05,1.05,0,0,0,1.01,1.325c10.612-1.413,21.451-.174,31.884-2.988a1.048,1.048,0,0,0-.557-2.019c-10.246,2.764-20.9,1.525-31.327,2.914l1.009,1.325c.049-.154,1.455-.8,1.706-1.014,1.036-.868-.453-2.341-1.48-1.48Z",
    fill: "#d7e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M637.179,251.8c4.287,1.683,9.4-.019,13.726-.738,1.329-.221.763-2.238-.557-2.018-3.976.661-8.682,2.281-12.612.738-1.258-.495-1.8,1.53-.557,2.018Z",
    fill: "#d7e0e0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M590.715,130.552a3.768,3.768,0,1,1-3.767-3.768A3.768,3.768,0,0,1,590.715,130.552Z",
    fill: "#ff1717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M671.095,123.853a3.767,3.767,0,1,1-3.767-3.768A3.768,3.768,0,0,1,671.095,123.853Z",
    fill: "#579334"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1575",
    "data-name": "Group 1575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M764.3,265.553a327.3,327.3,0,0,1-1.561-39.072c-9.469,7.14-36.082,1.449-36.082,1.449,2.414,13.92,3.629,31.3.112,44.651C739.065,271.575,752.218,268.749,764.3,265.553Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M766.061,262.039a327.1,327.1,0,0,1-1.561-39.072c-9.469,7.14-36.082,1.449-36.082,1.449,2.414,13.92,3.629,31.3.112,44.651C740.822,268.061,753.975,265.235,766.061,262.039Z",
    fill: "#ff5593"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M739.623,237.031c2.365,1.65,5.736,1.324,8.432.978a61.25,61.25,0,0,0,9.7-2.222.733.733,0,0,0-.39-1.412,70.165,70.165,0,0,1-8.326,2.018c-2.651.452-6.314,1.023-8.677-.627-.776-.542-1.507.728-.739,1.265Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M740.187,243.253c3.421-.531,6.915-.391,10.346-.852.921-.124.934-1.589,0-1.464-3.562.478-7.182.353-10.735.9-.931.145-.534,1.555.389,1.412Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M739.184,244.936c3.248,2.5,8.063,1.4,11.788.978.927-.1.937-1.57,0-1.464-3.445.393-8.05,1.53-11.049-.778-.748-.576-1.476.7-.739,1.264Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M735.795,251.6c6.512-1.8,13.346-1.745,20.008-2.608.923-.12.934-1.586,0-1.465-6.789.881-13.76.822-20.4,2.662a.732.732,0,0,0,.389,1.411Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M738.675,256.455c4.327-.479,8.655-.947,12.931-1.783.926-.181.533-1.592-.389-1.412-4.148.812-8.344,1.266-12.542,1.731-.928.1-.938,1.568,0,1.464Z",
    fill: "#aa3c6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M739.475,259.315c1.243.971,3.5.325,4.9.093a67.053,67.053,0,0,0,7.231-1.662.733.733,0,0,0-.389-1.412c-1.919.543-3.863,1-5.818,1.4-1.037.21-2.081.391-3.134.505-.362.039-1.529.217-1.755.04-.734-.574-1.778.455-1.035,1.036Z",
    fill: "#aa3c6e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1672",
    "data-name": "Group 1672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1670",
    "data-name": "Group 1670"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1582",
    "data-name": "Group 1582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M618.048,485.447a9.9,9.9,0,0,1-10.006,10.75H574.356a9.287,9.287,0,0,1-9.407-10.75l8.513-68.089c.741-5.938,4.638-10.751,8.7-10.751h23.059c4.064,0,7.692,4.813,8.1,10.751Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M608.88,483.566a7.81,7.81,0,0,1-7.991,8.4h-26.9a7.317,7.317,0,0,1-7.514-8.4l6.8-53.219c.593-4.64,3.706-8.4,6.952-8.4h18.416c3.246,0,6.144,3.763,6.473,8.4Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M588.355,487.37A17.745,17.745,0,1,1,606.1,469.626,17.765,17.765,0,0,1,588.355,487.37Zm0-34.169a16.424,16.424,0,1,0,16.424,16.425A16.443,16.443,0,0,0,588.355,453.2Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M588.355,456.011a13.615,13.615,0,1,0,13.614,13.614A13.629,13.629,0,0,0,588.355,456.011Z",
    fill: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M588.355,447.7a10.034,10.034,0,1,1,10.034-10.034A10.046,10.046,0,0,1,588.355,447.7Zm0-19.322a9.288,9.288,0,1,0,9.287,9.288A9.3,9.3,0,0,0,588.355,428.377Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M588.355,429.966a7.7,7.7,0,1,0,7.7,7.7A7.708,7.708,0,0,0,588.355,429.966Z",
    fill: "#3d3d3d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1584",
    "data-name": "Group 1584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1583",
    "data-name": "Group 1583"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 28.593,
    height: 326.418,
    transform: "translate(1054.185 514.769)",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 28.593,
    height: 11.399,
    transform: "translate(1054.185 829.788)",
    fill: "#212e35",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M1065.349,795.546c0,2.039-1.308,3.692-2.92,3.692h0c-1.612,0-2.919-1.653-2.919-3.692V532.464c0-2.039,1.307-3.693,2.919-3.693h0c1.612,0,2.92,1.654,2.92,3.693Z",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1586",
    "data-name": "Group 1586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 28.593,
    height: 326.418,
    transform: "translate(850.317 514.769)",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 28.593,
    height: 11.399,
    transform: "translate(850.317 829.788)",
    fill: "#212e35",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M861.479,795.546c0,2.039-1.306,3.692-2.919,3.692h0c-1.612,0-2.918-1.653-2.918-3.692V532.464c0-2.039,1.306-3.693,2.918-3.693h0c1.613,0,2.919,1.654,2.919,3.693Z",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1587",
    "data-name": "Group 1587"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 28.594,
    height: 326.418,
    transform: "translate(523.276 514.769)",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 28.594,
    height: 11.399,
    transform: "translate(523.276 829.788)",
    fill: "#212e35",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M534.439,795.546c0,2.039-1.307,3.692-2.919,3.692h0c-1.612,0-2.919-1.653-2.919-3.692V532.464c0-2.039,1.307-3.693,2.919-3.693h0c1.612,0,2.919,1.654,2.919,3.693Z",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 28.594,
    height: 326.418,
    transform: "translate(320.244 514.769)",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 28.594,
    height: 11.399,
    transform: "translate(320.244 829.788)",
    fill: "#212e35",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M331.408,795.546c0,2.039-1.307,3.692-2.92,3.692h0c-1.611,0-2.919-1.653-2.919-3.692V532.464c0-2.039,1.308-3.693,2.919-3.693h0c1.613,0,2.92,1.654,2.92,3.693Z",
    fill: "#ccc"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 765.287,
    height: 25.119,
    transform: "translate(319.041 508.212)",
    fill: "#302530"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 810.5,
    height: 16.746,
    transform: "translate(295.596 497.328)",
    fill: "#60485e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 222.59,
    height: 16.746,
    transform: "translate(883.506 497.328)",
    fill: "#423241"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M383.2,454.961l-1.456-.181A6.858,6.858,0,0,1,383.2,454.961Z",
    fill: "#603043"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M384.019,601.1c-17.1,2.482,5.532,10.392-9.285,15.782L450.277,628.5c38.58-2.336,149.048,4.5,166.775,0,6.344-1.61,39.243-.819,41.9-4.555C638.405,590.552,409.663,597.375,384.019,601.1Z",
    fill: "#00788c"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1607",
    "data-name": "Group 1607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1596",
    "data-name": "Group 1596"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 35.903,
    height: 74.928,
    transform: "translate(736.486 420.003)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 16.604,
    height: 74.928,
    transform: "translate(736.486 420.003)",
    fill: "#757573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1594",
    "data-name": "Group 1594"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M836.374,492.246a4.68,4.68,0,0,1-4.683,4.683H677.185a4.68,4.68,0,0,1,0-9.36H831.691A4.682,4.682,0,0,1,836.374,492.246Z",
    fill: "#999995"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M836.374,492.246c0,2.591-1.47,4.683-3.283,4.683h-55.8c-1.813,0-3.283-2.092-3.283-4.683a5.785,5.785,0,0,1,.963-3.3,2.887,2.887,0,0,1,2.32-1.374h55.8C834.9,487.569,836.374,489.666,836.374,492.246Z",
    fill: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1595",
    "data-name": "Group 1595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M887.3,289.147V431.069c0,8.179-5.494,14.984-12.746,16.419a14.363,14.363,0,0,1-2.861.281H621.978a14.387,14.387,0,0,1-2.862-.281c-7.252-1.435-12.746-8.24-12.746-16.419V289.147c0-9.219,6.992-16.694,15.608-16.694H871.693C880.313,272.453,887.3,279.928,887.3,289.147Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M868.7,295.063v130.1c0,8.454-6.318,15.306-14.117,15.306H628.729c-7.8,0-14.118-6.852-14.118-15.306v-130.1c0-8.455,6.32-15.306,14.118-15.306h225.85C862.378,279.757,868.7,286.608,868.7,295.063Z",
    fill: "#544753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M869.448,410.415v21.09c0,8.35-5.159,15.3-11.971,16.764H617.562c-6.812-1.465-11.971-8.414-11.971-16.764v-21.09Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M741.179,423.971c0,3.232-3.495,5.852-7.8,5.852s-7.8-2.62-7.8-5.852,3.494-5.853,7.8-5.853S741.179,420.738,741.179,423.971Z",
    fill: "#757573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1598",
    "data-name": "Group 1598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1597",
    "data-name": "Group 1597"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 12.922,
    height: 1.385,
    transform: "translate(624.645 287.96)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 17.537,
    height: 1.385,
    transform: "translate(693.872 287.96)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 57.228,
    height: 1.385,
    transform: "translate(715.102 287.96)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M811.558,289.345V287.96H776.022v1.385h12.923v-.923H793.1v.923Z",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 14.307,
    height: 1.385,
    transform: "translate(822.174 287.96)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 12.922,
    height: 1.385,
    transform: "translate(624.645 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 14.768,
    height: 1.385,
    transform: "translate(757.561 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 12.923,
    height: 1.385,
    transform: "translate(776.022 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 14.307,
    height: 1.385,
    transform: "translate(822.174 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 18.46,
    height: 1.385,
    transform: "translate(793.098 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 17.537,
    height: 1.385,
    transform: "translate(693.872 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 35.537,
    height: 1.385,
    transform: "translate(715.102 294.421)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 12.922,
    height: 1.385,
    transform: "translate(624.645 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 47.998,
    height: 1.385,
    transform: "translate(702.641 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 2.769,
    height: 1.385,
    transform: "translate(757.561 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 17.999,
    height: 1.385,
    transform: "translate(770.945 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 18.46,
    height: 1.385,
    transform: "translate(793.098 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 14.307,
    height: 1.385,
    transform: "translate(822.174 300.882)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 12.922,
    height: 1.384,
    transform: "translate(624.645 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 47.998,
    height: 1.384,
    transform: "translate(702.641 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 2.769,
    height: 1.384,
    transform: "translate(757.561 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 40.613,
    height: 1.384,
    transform: "translate(770.945 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 7.385,
    height: 1.384,
    transform: "translate(829.096 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 5.077,
    height: 1.384,
    transform: "translate(822.174 307.344)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 37.383,
    height: 1.384,
    transform: "translate(624.645 313.805)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 11.538,
    height: 1.384,
    transform: "translate(702.641 313.805)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 56.305,
    height: 1.384,
    transform: "translate(770.945 313.805)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 7.385,
    height: 1.384,
    transform: "translate(829.096 313.805)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 14.307,
    height: 1.384,
    transform: "translate(729.87 313.805)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M692.026,321.189h-30v-.922H624.645v1.384h67.381Z",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 14.307,
    height: 1.384,
    transform: "translate(729.87 320.266)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M770.945,320.266v.922H766.33v.462h30v-1.384Z",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 29.537,
    height: 1.384,
    transform: "translate(797.713 320.266)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 7.385,
    height: 1.384,
    transform: "translate(829.096 320.266)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 11.538,
    height: 1.384,
    transform: "translate(702.641 320.266)",
    fill: "#cacea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M624.645,326.727v1.384h1.846v-.462h4.154v.462h83.534v-1.384Z",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 14.307,
    height: 1.384,
    transform: "translate(729.87 326.727)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 29.999,
    height: 1.384,
    transform: "translate(766.33 326.727)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 29.537,
    height: 1.384,
    transform: "translate(797.713 326.727)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 7.385,
    height: 1.384,
    transform: "translate(829.096 326.727)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 1.846,
    height: 1.384,
    transform: "translate(624.645 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 83.534,
    height: 1.384,
    transform: "translate(630.645 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 14.307,
    height: 1.384,
    transform: "translate(729.87 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 29.999,
    height: 1.384,
    transform: "translate(766.33 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 29.537,
    height: 1.384,
    transform: "translate(797.713 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 7.385,
    height: 1.384,
    transform: "translate(829.096 333.188)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 83.534,
    height: 1.384,
    transform: "translate(630.645 339.65)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 11.999,
    height: 1.384,
    transform: "translate(729.87 339.65)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 24.922,
    height: 1.384,
    transform: "translate(766.33 339.65)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 21.691,
    height: 1.384,
    transform: "translate(814.789 339.65)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 4.615,
    height: 1.384,
    transform: "translate(801.867 339.65)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 24.922,
    height: 1.385,
    transform: "translate(766.33 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 4.615,
    height: 1.385,
    transform: "translate(801.867 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 5.538,
    height: 1.385,
    transform: "translate(814.789 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 13.845,
    height: 1.385,
    transform: "translate(822.635 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 11.999,
    height: 1.385,
    transform: "translate(729.87 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 13.846,
    height: 1.385,
    transform: "translate(630.645 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 69.228,
    height: 1.385,
    transform: "translate(644.951 346.111)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 11.999,
    height: 1.385,
    transform: "translate(729.87 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 24.922,
    height: 1.385,
    transform: "translate(766.33 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 4.615,
    height: 1.385,
    transform: "translate(801.867 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 5.538,
    height: 1.385,
    transform: "translate(814.789 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 13.845,
    height: 1.385,
    transform: "translate(822.635 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 69.228,
    height: 1.385,
    transform: "translate(644.951 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 13.846,
    height: 1.385,
    transform: "translate(630.645 352.572)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M630.645,359.033v.923h-4.154v-.923h-.461v1.385H644.49v-1.385Z",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 96.918,
    height: 1.385,
    transform: "translate(644.951 359.033)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 13.846,
    height: 1.385,
    transform: "translate(766.33 359.033)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 38.768,
    height: 1.385,
    transform: "translate(781.56 359.033)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 13.845,
    height: 1.385,
    transform: "translate(822.635 359.033)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 67.843,
    height: 1.385,
    transform: "translate(674.027 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 18.461,
    height: 1.385,
    transform: "translate(626.03 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 23.076,
    height: 1.385,
    transform: "translate(644.951 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 38.768,
    height: 1.385,
    transform: "translate(781.56 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 26.306,
    height: 1.385,
    transform: "translate(753.869 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 13.845,
    height: 1.385,
    transform: "translate(822.635 365.494)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 8.769,
    height: 1.385,
    transform: "translate(626.03 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 7.384,
    height: 1.385,
    transform: "translate(637.106 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 23.076,
    height: 1.385,
    transform: "translate(644.951 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 67.843,
    height: 1.385,
    transform: "translate(674.027 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 26.306,
    height: 1.385,
    transform: "translate(753.869 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 38.768,
    height: 1.385,
    transform: "translate(781.56 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 13.845,
    height: 1.385,
    transform: "translate(822.635 371.955)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 72.458,
    height: 1.385,
    transform: "translate(693.411 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 8.769,
    height: 1.385,
    transform: "translate(626.03 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 10.153,
    height: 1.385,
    transform: "translate(637.106 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 16.153,
    height: 1.385,
    transform: "translate(651.874 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 16.153,
    height: 1.385,
    transform: "translate(674.027 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 11.538,
    height: 1.385,
    transform: "translate(768.638 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 54.921,
    height: 1.385,
    transform: "translate(781.56 378.417)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 11.538,
    height: 1.385,
    transform: "translate(768.638 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 10.153,
    height: 1.385,
    transform: "translate(624.645 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 16.153,
    height: 1.385,
    transform: "translate(651.874 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 10.153,
    height: 1.385,
    transform: "translate(637.106 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 16.153,
    height: 1.385,
    transform: "translate(674.027 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 72.458,
    height: 1.385,
    transform: "translate(693.411 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 54.921,
    height: 1.385,
    transform: "translate(781.56 384.878)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 10.153,
    height: 1.385,
    transform: "translate(624.645 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 13.845,
    height: 1.385,
    transform: "translate(651.874 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 15.692,
    height: 1.385,
    transform: "translate(674.488 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 10.153,
    height: 1.385,
    transform: "translate(637.106 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 19.845,
    height: 1.385,
    transform: "translate(693.411 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 18.461,
    height: 1.385,
    transform: "translate(716.025 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 27.229,
    height: 1.385,
    transform: "translate(738.639 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 67.843,
    height: 1.385,
    transform: "translate(768.638 391.339)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 22.615,
    height: 1.385,
    transform: "translate(624.645 397.8)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 13.845,
    height: 1.385,
    transform: "translate(651.874 397.8)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 38.768,
    height: 1.385,
    transform: "translate(674.488 397.8)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 18.461,
    height: 1.385,
    transform: "translate(716.025 397.8)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 27.229,
    height: 1.385,
    transform: "translate(738.639 397.8)",
    fill: "#e0e8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 67.843,
    height: 1.385,
    transform: "translate(768.638 397.8)",
    fill: "#e0e8bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1602",
    "data-name": "Group 1602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1599",
    "data-name": "Group 1599"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 123.078,
    height: 92.745,
    transform: "translate(632.61 297.93)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 123.116,
    height: 6.944,
    transform: "translate(632.591 297.93)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1600",
    "data-name": "Group 1600"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M749.241,301.309a2.413,2.413,0,1,1-2.413-2.413A2.413,2.413,0,0,1,749.241,301.309Z",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M737.657,301.309a2.413,2.413,0,1,1-2.412-2.413A2.412,2.412,0,0,1,737.657,301.309Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M726.718,301.309A2.414,2.414,0,1,1,724.3,298.9,2.413,2.413,0,0,1,726.718,301.309Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1601",
    "data-name": "Group 1601"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 4.827,
    height: 1.379,
    transform: "translate(640.966 313.904)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 67.571,
    height: 1.379,
    transform: "translate(661.996 313.904)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 4.827,
    height: 1.379,
    transform: "translate(640.966 319.42)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M662,319.42V320.8h51.368v-1.034H724.4V320.8h.689V319.42Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 4.827,
    height: 1.38,
    transform: "translate(640.966 324.936)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 45.163,
    height: 1.38,
    transform: "translate(661.996 324.936)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M725.086,325.625v-.689H724.4v1.38h5.171v-.691Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M662,330.452v.689h-16.2v-.689h-4.827v1.379h38.957v-1.379Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 8.62,
    height: 1.379,
    transform: "translate(698.54 330.452)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 6.551,
    height: 1.379,
    transform: "translate(723.362 330.452)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 21.03,
    height: 1.379,
    transform: "translate(640.966 335.969)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 34.131,
    height: 1.379,
    transform: "translate(698.54 335.969)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 21.03,
    height: 1.379,
    transform: "translate(640.966 341.485)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M732.67,341.485H698.54v1.033H679.923v-1.033h-1.379v1.379H707.5v-1.035h7.239v1.035h4.137v-.691h13.79Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M694.058,347H678.544v.344H662V347h-21.03v1.379h53.092Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 1.724,
    height: 1.379,
    transform: "translate(705.779 347.001)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 4.137,
    height: 1.379,
    transform: "translate(714.743 347.001)",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 21.03,
    height: 1.379,
    transform: "translate(642 365.617)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 4.137,
    height: 1.379,
    transform: "translate(681.302 365.617)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 18.272,
    height: 1.379,
    transform: "translate(696.127 365.617)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 21.375,
    height: 1.379,
    transform: "translate(641.656 372.168)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 4.137,
    height: 1.379,
    transform: "translate(681.302 372.168)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 2.413,
    height: 1.379,
    transform: "translate(696.127 372.168)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 6.55,
    height: 1.379,
    transform: "translate(707.848 372.168)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 21.719,
    height: 1.379,
    transform: "translate(641.311 378.718)",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 31.373,
    height: 1.379,
    transform: "translate(681.302 378.718)",
    fill: "#ff5821"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1606",
    "data-name": "Group 1606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1603",
    "data-name": "Group 1603"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 90.829,
    height: 68.444,
    transform: "translate(764.901 333.887)",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 90.857,
    height: 5.125,
    transform: "translate(764.887 333.887)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1604",
    "data-name": "Group 1604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M850.973,336.38a1.781,1.781,0,1,1-1.781-1.781A1.782,1.782,0,0,1,850.973,336.38Z",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M842.424,336.38a1.781,1.781,0,1,1-1.78-1.781A1.781,1.781,0,0,1,842.424,336.38Z",
    fill: "#889f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M834.351,336.38a1.781,1.781,0,1,1-1.781-1.781A1.781,1.781,0,0,1,834.351,336.38Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 12.66,
    height: 0.487,
    transform: "translate(770.511 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 16.555,
    height: 0.487,
    transform: "translate(793.153 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 6.817,
    height: 0.487,
    transform: "translate(784.875 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 3.895,
    height: 0.487,
    transform: "translate(812.143 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 20.451,
    height: 0.487,
    transform: "translate(816.769 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 4.14,
    height: 0.487,
    transform: "translate(837.95 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 6.817,
    height: 0.487,
    transform: "translate(842.575 347.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 12.66,
    height: 0.73,
    transform: "translate(770.511 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 6.817,
    height: 0.73,
    transform: "translate(784.875 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 16.555,
    height: 0.73,
    transform: "translate(793.153 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 3.895,
    height: 0.73,
    transform: "translate(812.143 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M816.769,349.13v.73H828.7v-.487h.73v.487h7.791v-.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 4.14,
    height: 0.73,
    transform: "translate(837.95 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 6.817,
    height: 0.73,
    transform: "translate(842.575 349.13)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 21.425,
    height: 0.487,
    transform: "translate(770.511 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 8.521,
    height: 0.487,
    transform: "translate(792.423 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 6.817,
    height: 0.487,
    transform: "translate(802.892 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 16.555,
    height: 0.487,
    transform: "translate(812.143 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 10.955,
    height: 0.487,
    transform: "translate(838.437 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 7.791,
    height: 0.487,
    transform: "translate(829.429 355.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 8.521,
    height: 1.948,
    transform: "translate(792.423 356.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 21.425,
    height: 1.948,
    transform: "translate(770.511 356.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 6.817,
    height: 1.948,
    transform: "translate(802.892 356.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M837.219,356.677h-7.791v1.7h-.73v-1.7H812.143v1.948h25.076Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M838.437,356.677v1.948h3.9v-1.217H845.5v1.217h3.895v-1.948Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M782.2,366.035H770.755v2.252h6.817v-2.115H782.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 3.408,
    height: 0.137,
    transform: "translate(825.533 366.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M838.68,366.035v.137h4.382v2.115h6.573v-2.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 4.869,
    height: 0.137,
    transform: "translate(832.593 366.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 8.521,
    height: 0.867,
    transform: "translate(792.666 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 7.303,
    height: 1.461,
    transform: "translate(793.884 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M770.755,375.18v1.461h8.277v-1.217h.244v1.217h1.7V375.18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 9.252,
    height: 1.461,
    transform: "translate(781.224 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 10.956,
    height: 0.867,
    transform: "translate(781.224 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 8.277,
    height: 0.867,
    transform: "translate(770.755 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 1.704,
    height: 0.867,
    transform: "translate(779.276 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 5.6,
    height: 1.461,
    transform: "translate(803.135 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 5.6,
    height: 0.867,
    transform: "translate(803.135 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 4.869,
    height: 1.461,
    transform: "translate(832.593 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 16.555,
    height: 1.461,
    transform: "translate(812.387 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 16.555,
    height: 1.461,
    transform: "translate(811.549 388.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 16.555,
    height: 1.461,
    transform: "translate(831.435 388.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 16.799,
    height: 0.867,
    transform: "translate(812.387 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 4.869,
    height: 0.867,
    transform: "translate(832.593 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 3.895,
    height: 1.461,
    transform: "translate(838.68 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 3.895,
    height: 1.461,
    transform: "translate(845.74 375.18)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 3.895,
    height: 0.867,
    transform: "translate(838.68 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 3.895,
    height: 0.867,
    transform: "translate(845.74 379.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M801,383.618v.136h4.382v2.115h6.573v-2.252Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 4.869,
    height: 1.461,
    transform: "translate(794.915 392.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 16.556,
    height: 1.461,
    transform: "translate(774.708 392.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 16.799,
    height: 0.868,
    transform: "translate(774.708 397.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 4.869,
    height: 0.868,
    transform: "translate(794.915 397.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 3.895,
    height: 1.461,
    transform: "translate(801.002 392.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 3.895,
    height: 1.461,
    transform: "translate(808.062 392.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 3.895,
    height: 0.868,
    transform: "translate(801.002 397.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 3.895,
    height: 0.868,
    transform: "translate(808.062 397.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 12.66,
    height: 1.704,
    transform: "translate(770.511 344.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 6.817,
    height: 1.704,
    transform: "translate(784.875 344.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 16.555,
    height: 1.704,
    transform: "translate(793.153 344.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M837.219,345.965v-1.7H812.143v1.7h3.9v-1.217h.73v1.217Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M837.95,344.26v1.7h4.139v-.487h.486v.487h6.817v-1.7Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1609",
    "data-name": "Group 1609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1608",
    "data-name": "Group 1608"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 68.658,
    height: 5.582,
    transform: "matrix(1, -0.006, 0.006, 1, 706.697, 490.545)",
    fill: "#9c9e8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M573.569,491.322l-4.154,5.607,154.9-.9-.032-5.581Z",
    fill: "#c9ccbc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M589.356,486.487l-15.787,4.836,201.785-1.175-4.214-4.72Z",
    fill: "#3d3d3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1610",
    "data-name": "Group 1610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M862.07,496.929H811.5c4.986-7.547,13.245-14.824,28.746-13.884a31.074,31.074,0,0,1,5.421.8C854.234,485.924,860.081,491.407,862.07,496.929Z",
    fill: "#728425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M862.07,496.929H827.661c3.682-5.574,9.153-11,18.005-13.079C854.234,485.924,860.081,491.407,862.07,496.929Z",
    fill: "#889f33"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1618",
    "data-name": "Group 1618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1617",
    "data-name": "Group 1617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1615",
    "data-name": "Group 1615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M583.861,826.523c-8.4-4.749-15.456-18.436-18.827-26.847-5.435-13.557-3.716,10.112-14.177,7.492-4.292-1.074-7.118,5.3-8.12,8.995-2.391,8.816-.57,23.386.953,29.145,12.472,1.63,18.913,1.544,31.493,1.712,7.24.1,22.894.19,27.251-6.386C599.017,831.437,591.25,830.7,583.861,826.523Z",
    fill: "#212030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M546.384,758.505c-.208,10.429-1.883,20.252-.934,30.983.8,9.105-1.546,23.347,5.745,30.007,14.359-7.126,14.246-39.684,18.217-53.66Z",
    fill: "#ffa471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M537.423,790.658l28.8,1.822q1.308-5.5,2.573-11.039c11.889-51.866,30.372-108.59,33.828-163.217l-51.155-11.25c-9.128,1.076-14.373,32.853-15.939,43.9-3.462,24.452-.379,49.475.606,73.985C536.98,745.814,538.282,768.5,537.423,790.658Z",
    fill: "#212030"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1616",
    "data-name": "Group 1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M708.821,826.523c-8.4-4.749-15.455-18.436-18.828-26.847-5.433-13.557-3.715,10.112-14.176,7.492-4.292-1.074-7.117,5.3-8.12,8.995-2.391,8.816-.57,23.386.953,29.145,12.472,1.63,18.913,1.544,31.493,1.712,7.24.1,22.893.19,27.251-6.386C723.978,831.437,716.21,830.7,708.821,826.523Z",
    fill: "#212030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M671.344,758.505c-.207,10.429-1.883,20.252-.934,30.983.805,9.105-1.546,23.347,5.746,30.007,14.357-7.126,14.245-39.684,18.216-53.66Z",
    fill: "#ffa471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M727.584,618.225c-.005.07-.009.146-.017.217-2.407,37.686-11.956,76.374-21.543,113.767-4.3,16.738-8.595,33.216-12.267,49.233q-1.269,5.544-2.57,11.04l-28.8-1.825c.858-22.155-.444-44.842-1.285-65.795-.985-24.512-4.07-49.534-.608-73.988.34-2.394.854-5.764,1.541-9.586,1.721-9.571,4.543-21.963,8.494-28.941,1.746-3.086,3.714-5.112,5.907-5.372Z",
    fill: "#212030"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M727.567,618.442a20.923,20.923,0,0,1-3.684,6.5c-6.979,8.7-20.468,12.852-35.443,14.783a226.023,226.023,0,0,1-26.408,1.566c-10.244.092-19.84-.231-27.191-.231-20.869,0-41.517.055-62.086-1.675-11.165-.937-25.285.009-37.376-1.6a52.083,52.083,0,0,1-11.1-2.583l5.732-66.984c38.951-3.415,58.033-8.414,95.983-.418C638.994,570.532,737.585,587.931,727.567,618.442Z",
    fill: "#212030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M706.024,732.209c-4.3,16.738-8.595,33.216-12.267,49.233q-1.269,5.544-2.57,11.04l-28.8-1.825c.858-22.155-.444-44.842-1.285-65.795-.985-24.512-4.07-49.534-.608-73.988.34-2.394.854-5.764,1.541-9.586-10.244.092-19.84-.231-27.191-.231-20.869,0-41.517.055-62.086-1.675-11.165-.937-25.285.009-37.376-1.6l3.357-31.913c3.915,5.722,30.812,4.685,39.215,5.023,18.55.754,36.82.315,55.27,1.256,11.148.57,24.29.114,37.3.2,14.527.1,28.9.887,40.191,4.546-9.173,1.235-16.558,4.345-24.9,8.126,5.058,2.972,13.64,4.471,18.618,6.945-6.682-.774-11.911,2.42-16,7.758-10.5,13.714-13.447,41.609-14.049,52.812-.666,12.35.419,29.389,11.374,37.431C692.861,735.181,699.438,734.356,706.024,732.209Z",
    fill: "#171721"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1633",
    "data-name": "Group 1633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626",
    "data-name": "Group 1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1625",
    "data-name": "Group 1625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M556.445,286.046h-5.79a11.187,11.187,0,0,1-11.265-11.081v-3.374a11.187,11.187,0,0,1,11.265-11.082h5.79a11.187,11.187,0,0,1,11.265,11.082v3.374A11.187,11.187,0,0,1,556.445,286.046Zm-5.79-23.617a9.177,9.177,0,0,0-9.172,9.162v3.374a9.177,9.177,0,0,0,9.172,9.161h5.79a9.177,9.177,0,0,0,9.172-9.161v-3.374a9.178,9.178,0,0,0-9.172-9.162Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1620",
    "data-name": "Group 1620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1619",
    "data-name": "Group 1619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M551.2,280.19a157.159,157.159,0,0,0-.967,16.955,115.774,115.774,0,0,0,2.227,19.3c-7.083,2.6-17.778-6.229-22.378-10.9a42.448,42.448,0,0,1-12.041-25.468Z",
    fill: "#f2edee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M546.194,285.273c-4.159-.068-7.076,6.752-7.441,10.232-.677,6.48,5.544,12.547,4.228,18.607-4.791-1.844-10.541-8.082-14.212-11.743-3.742-3.732-10.536-10.887-10.285-16.545Z",
    fill: "#f2f0eb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M555.858,293.877c-.334,11.363-2.587,22.595-2.532,24.571l-.005.008a5.354,5.354,0,0,1,0,.6,6.053,6.053,0,0,1-.515,2.52,4.44,4.44,0,0,1-1.988,1.989c-4.074,2.151-9.37,2.348-14.394,1.389-.837-.159-1.67-.351-2.486-.573-.561-.147-1.11-.31-1.654-.486a32.013,32.013,0,0,1-5.187-2.189,16.927,16.927,0,0,1-5.358-4.2,6.574,6.574,0,0,1-1.009-1.809c-.013.273-.03.565-.042.884-.009.154-.017.309-.021.468-.005.063-.009.13-.009.2-.013.193-.021.39-.029.59,0,.067,0,.134-.008.2v.046c-.008.172-.013.344-.021.519-.009.231-.017.469-.029.708s-.017.5-.025.766c-.026.712-.055,1.465-.08,2.261-.038,1.21-.076,2.478-.113,3.78-.009.39-.021.783-.03,1.177-.063,2.281-.117,4.642-.167,6.941,0,.205-.008.41-.013.611-.037,1.641-.067,3.249-.1,4.764-.038,2.052-.071,3.94-.092,5.552-.05,3.169-.067,5.254-.05,5.341-.038.013-.08.021-.118.03-3.177.85-8.113,1.239-13.794,1.218-10.332-.034-23.126-1.427-32.257-3.873l0,0a34.331,34.331,0,0,1-8.791-3.4,9.551,9.551,0,0,1-1.826-1.411c-.016-.017-.033-.033-.046-.05-.084-.084-.159-.172-.234-.26,1.055-1.884,1.8-6.087,2.328-11.387.058-.586.117-1.185.167-1.8.084-.917.155-1.863.226-2.83.235-3.24.41-6.715.548-10.211.264-6.9.369-13.895.444-19.337v0c.042-2.876.071-5.321.113-7.092.034-1.357.042-2.537.029-3.5-.188-11.773-1.557-23.5-2.386-35.3-1.264-18.093,72.95-14.3,72.95-14.3,5.6,4.3,7.472,10.633,9.009,17.6l.075.352c.469,2.144.913,4.345,1.423,6.569.059.255.122.515.184.77.051.213.105.431.155.645.005.012.005.021.009.033.021.084.042.163.063.247.2.783.4,1.57.624,2.353.1.339.2.674.3,1.013.435,1.424.929,2.843,1.511,4.245.23.227.448.469.658.72a12.346,12.346,0,0,1,1.1,1.541,23.249,23.249,0,0,1,2.775,8.063A64.161,64.161,0,0,1,555.858,293.877Z",
    fill: "#ffa471"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M552.8,321.569a4.421,4.421,0,0,1-1.987,1.991c-10.144,5.358-27.861-1.42-30.086-7.866-.442,8.521-1.238,40.82-.885,42.474-12.123,3.331-50.648-7.9-57.01-15.422,3.706-6.632,3.572-41.947,3.825-52.656l51.069-11.955c.752,1.422-.1,4.474-.161,6.287-.082,2.314-.04,4.753.11,7.063a36.973,36.973,0,0,0,3.408,13.042c3.518,7.525,10.29,15.608,18.8,17.577A25.221,25.221,0,0,0,552.8,321.569Z",
    fill: "#e07f4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M560.459,287.112c-.341-.614-2.543-1.65-3.189-2.374-1.379-1.543-2.087-3.664-3.032-5.472-1.293-2.471-3.1-7.428-4.945-8.563l.773,24.339C552.877,294.07,564.319,294.059,560.459,287.112Z",
    fill: "#ffa471"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1623",
    "data-name": "Group 1623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622",
    "data-name": "Group 1622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1621",
    "data-name": "Group 1621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M552.363,273.075a2.414,2.414,0,0,1-.365.28,2.388,2.388,0,0,1-1.1.385,2.942,2.942,0,0,1-2.34-1.055,7.624,7.624,0,0,1-1.809-4.537,9.051,9.051,0,0,1,.068-2.14,6.088,6.088,0,0,1,1.28-3.085c.005.012.005.021.009.033.021.084.042.163.063.247.2.783.4,1.57.624,2.353.1.339.2.674.3,1.013.435,1.424.929,2.843,1.511,4.245.23.227.448.469.658.72A12.346,12.346,0,0,1,552.363,273.075Z",
    fill: "#121c26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M548.792,265.556a13.97,13.97,0,0,0-1.976.452c-1.679.515-3.023,1.311-3.371,2.257a7.707,7.707,0,0,1,4.5-5.987c.051.213.105.431.155.645.005.012.005.021.009.033.021.084.042.163.063.247C548.364,263.986,548.57,264.773,548.792,265.556Z",
    fill: "#121c26"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M550.452,256.1c-1.687-1.714-6.181-2.2-8.983-.327-2.982,1.62-6.737,5.885-6.206,7.238.252,1.108,7.923-.4,9.79-.882C546.881,261.527,555.007,260.924,550.452,256.1Z",
    fill: "#49211c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M463.182,230.341c6.6-19.434,26-17.187,48.283-16.42a106.979,106.979,0,0,1,41.257,9.8c-.344,15.5,1.116,16.455-5.051,30.556-3.87.52-16.273,21.459-31.386,10.457,5.5,9.467,6.223,33.634,1.188,44.33-4.61,9.784-8.092,3.288-15.965,8.981a28.338,28.338,0,0,0-5.975-7.5c.855,5.543,2.715,11.356,1.78,17.152-6.532,3.573-12.546,3.874-20.134,4.225-10.978.508-12.376-.6-15.593-10.513-4.936-15.2-4.085-23.209-10.995-37.679C445.341,268.685,435.221,244.641,463.182,230.341Z",
    fill: "#49211c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M513.877,278.738l52.158-9.028.628,3.14-50.72,9.018Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1624",
    "data-name": "Group 1624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M506.194,277.875c6.692-7.676,14.513,2,17.623,5.827,0,0-.075,13.338-3.671,16.424-4.353,3.733-10.666.169-13.451-3.615C503,291.487,501.182,283.626,506.194,277.875Z",
    fill: "#ffa471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M506.461,282.129c2.1-5.824,7.661-3.02,10.117.9-8.587-3.258-9.514,6.663-7.373,12.271C507.108,291.355,504.791,286.775,506.461,282.129Z",
    fill: "#e07f4f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M586.525,570.591l-.448.238c-10.2,5.346-29.473,10.713-41.505,13.3-3.043.648-5.618,1.125-7.473,1.377-20.459,2.788-40.248,2.478-60.188-1.955-5.263-19.216-17.424-36.95-21.887-56.572-5.154-22.666-13.723-55.487-14.812-79.024-.808-17.416-11.91-62.743-10.856-80.292.775-12.895,18.228,1.251,22.465-10.241l.126-10.511c-.8-6.33-1.926-13-.879-19.522,19.261-.745,45.8-3.249,62.818,4.789,15.28,7.222,33.738,9.713,47.282,21.921,7.786,7.012,10.265,66.242,14.233,119.8,3.178,42.856,7.3,82.084,15.863,88.037C594.873,564.445,592.248,567.509,586.525,570.591Z",
    fill: "#ff5821"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M586.077,570.829c-10.2,5.346-29.473,10.713-41.505,13.3-3.441-26.76,6.242-66.272,1.21-85.614-5.225-20.061-6.874-37.435-10.047-57.769-1.382-8.863.2-27.354-.252-36.272-.322-6.375,1.307-14.213-.841-20.053l21.77,53.587c1.725,13.761,12.077,24.2,18.989,35.891,3.178,42.856,7.3,82.084,15.863,88.037C592.294,562.649,594.763,566.33,586.077,570.829Z",
    fill: "#d83a0f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1628",
    "data-name": "Group 1628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1627",
    "data-name": "Group 1627"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 23.444,
    cy: 23.444,
    r: 23.444,
    transform: "translate(486.184 342.124) rotate(-80.783)",
    fill: "#212030"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 17.165,
    cy: 17.165,
    r: 17.165,
    transform: "matrix(0.045, -0.999, 0.999, 0.045, 498.924, 339.107)",
    fill: "#3c3c56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 11.513,
    cy: 11.513,
    r: 11.513,
    transform: "translate(504.545 322.738) rotate(-45)",
    fill: "#212030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M521.664,318.272c-19.005,6.048-49.451,1.63-67.642-5.705.084,3.682-.811,11.682-.6,15.334,9.3,4.09,19.007,4.529,29.306,5.024,10.685.513,30.5-2.278,40.19-6.7Z",
    fill: "#8a8a8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M527.106,322.04a4.605,4.605,0,1,1-4.605-4.605A4.6,4.6,0,0,1,527.106,322.04Z",
    fill: "#8a8a8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1630",
    "data-name": "Group 1630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M611.016,494.074c-.34.281-.682.557-1.034.825-5.4,4.132-12.43,6.288-26.04-4.283-1.528-1.185-3.136-2.529-4.831-4.048-10.822-9.683-19.828-29.225-28.154-40.613q-1.432-1.959-2.86-4.048c-13.668-20-26.58-48.592-26.232-72.64.147-10.135,2.466-17.822,12.25-20.6,6.581-1.867,18.948-9.248,34.9,16.093,0,0,26.111,54.6,38.239,93.107C612.917,475.846,615.533,490.315,611.016,494.074Z",
    fill: "#ff5821"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1629",
    "data-name": "Group 1629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M702.846,469.3c-9.682-3.224-21.441,2.995-30.26,6.876l8.941,9.18c6.826,1.31,9.654,1.354,16.511,1.16,18.751-.531,20.609,2.417,26.915.725C723.576,478.913,712.4,472.486,702.846,469.3Z",
    fill: "#ffa471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M688.85,487.368c-.8,1.679-19.09,6.309-37.079,10.277-14.958,3.3-29.715,6.134-34.04,6.431-13.141.9-26.019-3.944-33.789-13.46a33.029,33.029,0,0,1-7.3-18.424c-.047-.507-.08-1.022-.1-1.541l16.683-12.605a37.064,37.064,0,0,1,14.033-.176c16.709,2.688,35.5,13.828,72.736,14.137C679.992,472.007,690.726,483.436,688.85,487.368Z",
    fill: "#ff5821"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1632",
    "data-name": "Group 1632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1631",
    "data-name": "Group 1631"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M651.771,497.645c-14.958,3.3-29.715,6.134-34.04,6.431-13.141.9-26.019-3.944-33.789-13.46-1.528-1.185-3.136-2.529-4.831-4.048-10.822-9.683-19.828-29.225-28.154-40.613q-1.432-1.959-2.86-4.048c-6.623-19.429-14.274-30.89-13.617-50.772,6.908,32.025,35.893,72.395,42.161,81.057A98.689,98.689,0,0,0,594.576,491.5c-.872-4.689-.658-10-.3-14.732,3.8,9.424,9.051,14.992,15.7,18.127,7.28,3.433,16.239,3.956,26.81,3.433C641.64,498.094,646.706,497.9,651.771,497.645Z",
    fill: "#d83a0f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1668",
    "data-name": "Group 1668"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1637",
    "data-name": "Group 1637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1636",
    "data-name": "Group 1636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634",
    "data-name": "Group 1634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M428.475,711.465c0,2.627-1.479,4.758-3.3,4.758H402.968c-1.824,0-3.3-2.131-3.3-4.758h0c0-2.626,1.479-4.758,3.3-4.758h22.205c1.823,0,3.3,2.132,3.3,4.758Z",
    fill: "#44283e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1635",
    "data-name": "Group 1635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M418.743,713.514c7.835-1.249,15.827-.664,23.662-1.965,7.927-1.315,14.455-5.682,20.978-10.106,6.438-4.369,12.806-8.887,19.967-12.02,7.722-3.378,16.639-3.2,24.855-4.338,2.413-.335,1.382-3.988-1.007-3.656-8.24,1.145-16.9,1.083-24.711,4.277-7.179,2.937-13.569,7.378-19.941,11.73-6.638,4.533-13.1,9-21.149,10.458-7.8,1.412-15.828.716-23.66,1.967-2.41.383-1.384,4.037,1.006,3.653Z",
    fill: "#44283e"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1638",
    "data-name": "Group 1638"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 282.014,
    height: 28.583,
    rx: 11.372,
    transform: "translate(384.621 636.763)",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M678.5,636.763v1.04c0,7.081-4.894,13.154-11.862,15.724v.447a11.371,11.371,0,0,1-11.372,11.372H495.492a11.371,11.371,0,0,1-11.338-10.508q-.034-.428-.034-.864v-5.838a11.375,11.375,0,0,1,11.372-11.373Z",
    fill: "#44283e"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1639",
    "data-name": "Group 1639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M543.463,696.541h-28.8L425.51,651.055h205.6Z",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M532.3,696.54H514.351L425.2,651.055h64.14Z",
    fill: "#553d57"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 13.899,
    height: 48.521,
    transform: "translate(521.186 698.816)",
    fill: "#44283e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1640",
    "data-name": "Group 1640"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 9.735,
    height: 72.659,
    transform: "translate(521.884 720.043)",
    fill: "#49363e",
    opacity: 0.7,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 22.239,
    height: 72.659,
    transform: "translate(517.016 720.043)",
    fill: "#44283e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 9.736,
    height: 72.659,
    transform: "translate(517.016 720.043)",
    fill: "#69698e"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1641",
    "data-name": "Group 1641"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M546.328,701.214c0,2.584-1.651,4.677-3.686,4.677H513.661c-2.035,0-3.685-2.093-3.685-4.677a5.353,5.353,0,0,1,1.079-3.306,3.337,3.337,0,0,1,2.606-1.368h28.981C544.677,696.54,546.328,698.633,546.328,701.214Z",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M546.328,701.214c0,2.584-1.651,4.677-3.686,4.677h-10.8c-2.035,0-3.685-2.093-3.685-4.677a5.347,5.347,0,0,1,1.079-3.306,3.341,3.341,0,0,1,2.606-1.368h10.8C544.677,696.54,546.328,698.633,546.328,701.214Z",
    fill: "#44283e"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1650",
    "data-name": "Group 1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1643",
    "data-name": "Group 1643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1642",
    "data-name": "Group 1642"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M535.7,787.872v40.641a6.925,6.925,0,0,1-2.631,5.443,6.781,6.781,0,0,1-1.868,1.065,6.934,6.934,0,0,1-6.771-1.065,6.549,6.549,0,0,1-.595-.527,6.929,6.929,0,0,1-2.036-4.916V787.872a6.957,6.957,0,0,1,9.4-6.5,6.857,6.857,0,0,1,1.868,1.064,6.741,6.741,0,0,1,.595.528A6.923,6.923,0,0,1,535.7,787.872Z",
    fill: "#44283e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M529.753,813.343a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V789.566a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1Z",
    fill: "#553d57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1649",
    "data-name": "Group 1649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1644",
    "data-name": "Group 1644"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 9.419,
    height: 13.66,
    transform: "translate(522.872 812.392)",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 3.543,
    height: 13.66,
    transform: "translate(522.872 812.392)",
    fill: "#69698e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1648",
    "data-name": "Group 1648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M523.957,834.995a13.727,13.727,0,1,1-13.727-13.727A13.726,13.726,0,0,1,523.957,834.995Z",
    fill: "#2d2d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M517.093,834.995a6.864,6.864,0,1,1-6.863-6.864A6.863,6.863,0,0,1,517.093,834.995Z",
    fill: "#1d1d28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1647",
    "data-name": "Group 1647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646",
    "data-name": "Group 1646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M534,830.415H494.228c.435-7.064,9.166-12.7,19.882-12.7a29.45,29.45,0,0,1,4.356.319C527.106,819.314,533.621,824.336,534,830.415Z",
    fill: "#69698e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M534,830.415H502.936c.38-6.079,6.9-11.1,15.53-12.381C527.106,819.314,533.621,824.336,534,830.415Z",
    fill: "#44283e"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1657",
    "data-name": "Group 1657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1656",
    "data-name": "Group 1656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1651",
    "data-name": "Group 1651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 9.42,
    height: 13.66,
    transform: "translate(401.004 810.613)",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 3.544,
    height: 13.66,
    transform: "translate(401.004 810.613)",
    fill: "#49363e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M402.091,833.215a13.728,13.728,0,1,1-13.728-13.727A13.728,13.728,0,0,1,402.091,833.215Z",
    fill: "#2d2d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M395.226,833.215a6.864,6.864,0,1,1-6.863-6.863A6.865,6.865,0,0,1,395.226,833.215Z",
    fill: "#1d1d28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1654",
    "data-name": "Group 1654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1653",
    "data-name": "Group 1653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M412.13,828.635H372.36c.436-7.063,9.166-12.7,19.883-12.7a29.448,29.448,0,0,1,4.356.32C405.238,817.534,411.754,822.557,412.13,828.635Z",
    fill: "#69698e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M412.13,828.635H381.069c.38-6.078,6.9-11.1,15.53-12.381C405.238,817.534,411.754,822.557,412.13,828.635Z",
    fill: "#44283e"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M517.08,771.063c-7.7,1.361-110.69,23.547-124.079,37.273-3.6,3.687,5.353,5.758,9.349,5.007l114.73-21.589Z",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M517.08,771.063V781.8c-17.194,2.813-108.19,18.066-123.127,27.726a1.82,1.82,0,0,0-.853,2.042c-1.076-.841-1.364-1.937-.1-3.233C406.39,794.612,509.381,772.424,517.08,771.063Z",
    fill: "#69698e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M517,771.063v2.274c-7.433,1.317-105.931,22.166-124.756,35.956a3.331,3.331,0,0,1,.679-.955C406.312,794.612,509.3,772.424,517,771.063Z",
    fill: "#69698e"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1664",
    "data-name": "Group 1664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 9.42,
    height: 13.66,
    transform: "translate(645.88 810.613)",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 3.544,
    height: 13.66,
    transform: "translate(651.755 810.613)",
    fill: "#49363e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1662",
    "data-name": "Group 1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1659",
    "data-name": "Group 1659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M654.214,833.215a13.728,13.728,0,1,0,13.727-13.727A13.727,13.727,0,0,0,654.214,833.215Z",
    fill: "#2d2d3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M661.077,833.215a6.864,6.864,0,1,0,6.864-6.863A6.865,6.865,0,0,0,661.077,833.215Z",
    fill: "#1d1d28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1661",
    "data-name": "Group 1661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1660",
    "data-name": "Group 1660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M644.175,828.635h39.768c-.434-7.063-9.165-12.7-19.882-12.7a29.473,29.473,0,0,0-4.357.32C651.065,817.534,644.549,822.557,644.175,828.635Z",
    fill: "#69698e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M644.175,828.635h31.06c-.38-6.078-6.9-11.1-15.531-12.381C651.065,817.534,644.549,822.557,644.175,828.635Z",
    fill: "#44283e"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M539.224,771.063c7.7,1.361,110.69,23.547,124.078,37.273,3.6,3.687-5.352,5.758-9.349,5.007L539.224,791.754Z",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M539.224,771.063V781.8c17.194,2.813,108.191,18.066,123.127,27.726a1.818,1.818,0,0,1,.852,2.042c1.076-.841,1.364-1.937.1-3.233C649.914,794.612,546.923,772.424,539.224,771.063Z",
    fill: "#69698e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M539.3,771.063v2.274c7.432,1.317,105.931,22.166,124.755,35.956a3.344,3.344,0,0,0-.678-.955C649.992,794.612,547,772.424,539.3,771.063Z",
    fill: "#69698e"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1665",
    "data-name": "Group 1665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M638.278,515.737c-4.2-2.57-13.035-3.032-17.822-3.032H535.781c2.851,7.433,5.164,15.113,7.569,22.744h79.19c.034.007.068.018.1.026h0a.246.246,0,0,1,.042.027s.008,0,.011.007a8.1,8.1,0,0,1,.667.577l.008.011c.019.027.035.052.053.079.174.27.334.547.486.83l0,.009c.182.565.338,1.133.467,1.713v0c.1,1.824.03,3.666.03,5.486v74.642a11.48,11.48,0,0,0,11.372,11.373,10.733,10.733,0,0,0,2.676-.334,11.5,11.5,0,0,0,8.7-11.039V540.07C647.157,530.319,646.7,520.892,638.278,515.737Z",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M622.809,535.373c-.083-.1-.125-.156-.136-.174a1.339,1.339,0,0,1,.154.178S622.816,535.373,622.809,535.373Z",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M622.877,535.46l0-.008a.03.03,0,0,1,.018,0l.012.015Z",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M623.113,535.744c-.054-.063-.1-.117-.137-.169,0,0,.011,0,.019.006l.125.167Z",
    fill: "#553d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M631.149,524.077c-4.2-2.57-14.265-3.033-19.056-3.033H538.759c1.6,4.772,3.076,9.6,4.591,14.4h79.19c.034.007.068.018.1.026h0a.246.246,0,0,1,.042.027s.008,0,.011.007a8.1,8.1,0,0,1,.667.577l.008.011c.019.027.035.052.053.079.174.27.334.547.486.83l0,.009c.182.565.338,1.133.467,1.713v0c.1,1.824.03,3.666.03,5.486v74.642a11.48,11.48,0,0,0,11.372,11.373,10.733,10.733,0,0,0,2.676-.334,10.815,10.815,0,0,0,.337-2.7V548.41C638.8,538.659,639.576,529.233,631.149,524.077Z",
    fill: "#44283e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M627.358,519.433c9.594.139,13.953,8.914,13.742,17.532-.046,1.835,2.8,1.83,2.842,0,.127-5.146-.989-10.529-4.3-14.6a15.783,15.783,0,0,0-12.283-5.771,1.422,1.422,0,0,0,0,2.843Z",
    fill: "#717199"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1667",
    "data-name": "Group 1667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1666",
    "data-name": "Group 1666"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M374.941,337.8a15.846,15.846,0,0,0,15.881,15.809l70.885-.162a15.844,15.844,0,0,0,15.808-15.88l-.057-25.357A15.845,15.845,0,0,0,461.577,296.4l-70.886.161a15.845,15.845,0,0,0-15.808,15.881Z",
    fill: "#00b8d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M374.981,338.979a15.844,15.844,0,0,0,15.831,14.626l70.886-.161a15.845,15.845,0,0,0,15.81-15.881l-.057-25.356a15.845,15.845,0,0,0-14.872-15.778c.032.391.047.785.049,1.183l.059,25.355a15.846,15.846,0,0,1-15.809,15.882l-70.886.16C375.653,339.011,375.316,339,374.981,338.979Z",
    fill: "#663445",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M563.633,582.764c-.494,11.023.272,25.537-2.792,37.1a41.1,41.1,0,0,1-1.4,4.346c-.03.092-.067.184-.1.276-.226.578-5.589,31.127-5.849,31.679-25.34.314-59.222.917-90.026,1.181-17.386.146-33.793.184-47.131,0-19.178-.264-32.022-.992-32.328-2.516-7.929,0-14.757-7.017-15.494-16.2l-1.047-13.066-.322-4.036-20.308-253.1a19.471,19.471,0,0,1-.042-2.574c.406-8.47,6.2-15.407,13.832-16.018,1.767-.753,8.687-1.842,17.219-2.939,3.835-.489,7.992-.984,12.153-1.452,10.1-1.135,57.426-2.286,85.68-.452.005,0,.005,0,.009,0,5.028.322,9.453.744,12.957,1.276,24.1,3.651,35.284,17.458,39.415,41.84.139.837.285,1.674.427,2.516q1.872,10.939,3.806,21.878.829,4.666,1.662,9.336,3.636,20.247,7.485,40.592.617,3.291,1.244,6.586c.171.895.351,1.8.54,2.7,5.162,24.829,16.223,49.379,18.8,74.46.465,4.559.892,9.164,1.206,13.791A202.945,202.945,0,0,1,563.633,582.764Z",
    fill: "#00b8d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M520.831,605.927a31.918,31.918,0,0,1-11.375,13.941c-37.142,26.656-137.567,6.749-141.993,5.7l-.322-4.036-20.308-253.1a19.471,19.471,0,0,1-.042-2.574c2.767-.762,5.564-1.6,8.347-2.45a183.726,183.726,0,0,1,19.7-5.308c1.382-.255,2.738-.456,4.057-.6,21.309-2.278,41.864-.185,62.8,1.042,18.3,1.071,40.006.841,55.023,12.806,15.268,12.166,15.31,33.94,17.763,51.255,5.635,39.742,10.156,81.808,10.114,123.028C524.577,564,527.579,589.286,520.831,605.927Z",
    fill: "#663445",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M679.334,636.911v3.4c0,7.079-7.221,13.154-17.5,15.725a45.544,45.544,0,0,1-10.969,1.31H416.332c-19.178-.264-32.022-.992-32.328-2.516-7.929,0-14.757-7.017-15.494-16.2l-1.047-13.066-.322-4.036a44.81,44.81,0,0,1,12.292-1.666H650.862C666.587,619.868,679.334,627.5,679.334,636.911Z",
    fill: "#00b8d6"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M797.729,463.7q0,1.426-.071,2.827c0,.028,0,.058,0,.086s0,.029,0,.044,0,.033,0,.047c-.012.232-.025.463-.041.693a50.583,50.583,0,0,1-3.155,14.761,38.24,38.24,0,0,1-4.613,8.671,26.328,26.328,0,0,1-6.408,6.4H763.5a25.9,25.9,0,0,1-5.971-5.809c-5.1-6.74-8.326-16.66-8.326-27.72a55.135,55.135,0,0,1,.657-8.529h47.214a54.863,54.863,0,0,1,.625,6.63Q797.73,462.745,797.729,463.7Z",
    fill: "#ff2e2e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M797.626,466.369c-.075-.308.041.533.027.216s-.1.524-.033.205c.1-.531-.186.3.031-.091.046-.082.1-.16.154-.238.212-.309-.291.355-.038.056a6.278,6.278,0,0,1,.578-.576c.1-.086.194-.167.293-.249.353-.292-.33.244.05-.039.233-.175.475-.337.719-.5a20.8,20.8,0,0,1,1.8-1.04c.61-.318,1.235-.606,1.866-.878-.363.157.168-.066.2-.078.161-.065.324-.128.487-.19.376-.144.757-.277,1.138-.406q.939-.315,1.9-.55c.3-.073.6-.137.9-.2.143-.028.286-.051.43-.075.349-.057-.364.036.185-.022a7.332,7.332,0,0,1,3.644.519c.567.205-.3-.148.236.1.166.075.326.162.486.247a8.215,8.215,0,0,1,.9.571c-.311-.223.134.118.159.141.129.111.252.232.373.351s.234.247.345.374c.138.168.146.172.026.015.068.089.133.181.2.273a7.605,7.605,0,0,1,.512.871c.02.04.239.549.086.172.064.158.118.32.171.483a7.945,7.945,0,0,1,.248,1.01c.107.565-.032-.375.028.2.024.24.031.482.035.723a10.363,10.363,0,0,1-1.025,4.2c-1.341,2.837-3.611,4.618-6.443,6.088a26.687,26.687,0,0,1-4.364,1.766c-1.57.512-3.172.925-4.779,1.3a47.819,47.819,0,0,0-6.741,1.691,6.79,6.79,0,0,0-3.28,2.386,4.449,4.449,0,0,0-.1,4.312c1.211,2.8,4.145,3.476,6.788,2.332a3.89,3.89,0,0,0,2.225-2.588,3.7,3.7,0,0,0-1.887-3.806,1.883,1.883,0,0,0-2.565.673,1.909,1.909,0,0,0,.672,2.566c.455.313-.24-.23.12.1.338.311-.193-.321.036.023s-.123-.406-.015-.046c-.132-.443-.025-.323-.033-.1.022-.571-.089.011.127-.479-.052.118-.27.4.07-.035a2.029,2.029,0,0,1-.226.238c-.218.208.351-.222-.09.05a3.265,3.265,0,0,1-.327.17c.464-.22.084-.047-.027-.012a3.832,3.832,0,0,1-.377.092c-.444.092.433-.035-.019-.006a3.42,3.42,0,0,1-.392-.005c-.451-.023.424.085-.015-.013-.106-.023-.507-.183-.041.018-.111-.047-.564-.373-.174-.06a2.431,2.431,0,0,1-.29-.293c.3.338.019-.023-.029-.112-.081-.148-.158-.3-.23-.451.184.392,0-.036-.02-.112-.034-.109-.112-.567-.038-.018a2.526,2.526,0,0,1-.014-.359c0-.413-.092.446-.007.055.107-.493-.135.221,0-.053a2.353,2.353,0,0,1,.171-.274c-.3.437-.1.143-.005.045a3.307,3.307,0,0,1,.257-.231c-.4.338-.089.078.01.012a5.912,5.912,0,0,1,.67-.371c.085-.041.507-.218.046-.028.172-.071.347-.133.522-.2a70.86,70.86,0,0,1,6.975-1.675,40.991,40.991,0,0,0,9.632-3.448,17.209,17.209,0,0,0,7.264-6.9c1.6-3.012,2.349-6.759,1.032-10.013a10.03,10.03,0,0,0-7.563-6.036,15.359,15.359,0,0,0-8.171,1.069,25.315,25.315,0,0,0-6.3,3.182c-1.57,1.146-3.315,2.8-2.785,4.95.579,2.347,4.2,1.352,3.616-1Z",
    fill: "#ff2e2e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M783.612,459.875c0,17.868-9.547,32.353-21.323,32.353a14.527,14.527,0,0,1-4.762-.809c-5.1-6.74-8.326-16.66-8.326-27.72a55.135,55.135,0,0,1,.657-8.529h33.529Q783.611,457.474,783.612,459.875Z",
    fill: "#f55"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M753.349,461.8c-1.128,4.083-.271,8.618.855,12.6a47.612,47.612,0,0,0,2.253,6.159,24.239,24.239,0,0,0,2.408,4.407,2.25,2.25,0,0,0,3.018.791,2.211,2.211,0,0,0,.792-3.018,24.023,24.023,0,0,1-2.258-4.07c-.077-.168-.151-.338-.225-.507-.051-.115-.1-.23-.149-.346.1.234.1.234,0,0-.2-.485-.387-.976-.569-1.469-.356-.96-.671-1.934-.959-2.917s-.54-2-.752-3.016c-.1-.466-.181-.934-.258-1.4-.014-.087-.13-.921-.064-.4-.034-.26-.06-.521-.086-.782a19.812,19.812,0,0,1-.079-2.8c.007-.175.02-.35.034-.526.009-.12.111-.886.021-.261a10.11,10.11,0,0,1,.271-1.266,2.206,2.206,0,1,0-4.254-1.173Z",
    fill: "#fc8f35",
    opacity: 0.5,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1673);
export default __webpack_public_path__ + "static/media/Group 1673.bcf47681afd4b306e8a67cd8bdbea82c.svg";
export { ForwardRef as ReactComponent };